export default {
    init() {
        const floatContainers = document.querySelectorAll('.form-row');

        floatContainers.forEach((element) => {
            const input = element.querySelector(['input', 'textarea']);
            if (input !== null) {
                if (input.hasAttribute('placeholder')) {
                    input.removeAttribute('placeholder');
                }
                if (input.value) element.classList.add('active');

                input.addEventListener('focus', () => {
                    this.handleFocus(element);
                });
                input.addEventListener('blur', (e) => {
                    this.handleBlur(e, element);
                }, true);
            }
        });
    },

    handleFocus(element) {
        element.classList.add('active');
    },

    handleBlur({ currentTarget }, element) {
        if (!currentTarget.value) {
            element.classList.remove('active');
        }
    },
};

